module.exports = __webpack_public_path__ + "static/img/203.d1ee012.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210407/203.jpg
// module id = B+rK
// module chunks = 0